/**
 * Portal 公共外壳:站点页头 + 页脚(与首页同一套 SiteHeader/SiteFooter,
 * 视觉与链接集合一致)。导航一律真实 <a href>(spec §4:导航必须是真实
 * 链接;跨 app 跳转整页导航,无客户端路由)。各页 MPA 入口各自挂载一份,
 * 无共享运行时状态。
 */
import type { ReactNode } from 'react';
import { SITE_NAV_LINKS, SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

export interface PortalLayoutProps {
  readonly children: ReactNode;
  /** 主内容区额外 class(如窄栏表单页 vs 宽栏内容页)。 */
  readonly mainClassName?: string;
  /** 壳级额外 class(如 login cover 背景)。 */
  readonly shellClassName?: string;
  /**
   * 转化漏斗页(登录/注册/找回密码)传 false:页头只留品牌 + 会话区,
   * 不给「捐助/画廊」这类离开表单的出口。
   */
  readonly showNavLinks?: boolean;
}

export function PortalLayout({
  children,
  mainClassName,
  shellClassName,
  showNavLinks = true,
}: PortalLayoutProps) {
  const shellClass = shellClassName === undefined ? 'wv-portal-shell' : `wv-portal-shell ${shellClassName}`;
  return (
    <div className={shellClass}>
      <SiteHeader variant="solid" links={showNavLinks ? SITE_NAV_LINKS : undefined} />
      <main className={mainClassName === undefined ? 'wv-portal-main' : `wv-portal-main ${mainClassName}`}>
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}
